// extracted by mini-css-extract-plugin
module.exports = {"paymentList":"style_paymentList__3Z5Xn"};